import Helper from "./Helper";

class interactiveMap {
  constructor(config = {}) {
    const {
      map,
      mapContainer,
      buttons,
      overlays,
      closebtn,
      backdrops
    } = config;
    this.map = document.querySelector(map);
    this.mapContainer = document.querySelector(mapContainer);

    this.buttons = document.querySelectorAll(buttons);
    this.buttonsArray = Array.prototype.slice.call(this.buttons);

    this.overlaysString = overlays;
    this.overlays = document.querySelectorAll(overlays);
    this.overlaysArray = Array.prototype.slice.call(this.overlays);
    this.overlaysString = overlays;

    this.closebtn = document.querySelectorAll(closebtn);
    this.closebtnArray = Array.prototype.slice.call(this.closebtn);

    this.backdrops = document.querySelectorAll(backdrops);
    this.backdropsArray = Array.prototype.slice.call(this.backdrops);

    if (this.map) {
      Helper.loadImagesInContainer(mapContainer);
      this.bindEvents();
    }
  }

  bindEvents() {
    this.buttonsArray.forEach(item => {
      item.addEventListener("click", e => {
        //remove first all active classes on overlay
        this.overlaysArray.forEach(el => {
          Helper.removeClass(el, "active");
        });

        //get the id of button and activate the target overlay with a class
        const theId = e.currentTarget.id;
        const targetOverlay = document.querySelector(".overlay__" + theId);

        Helper.addClass(targetOverlay, "is-visible");
        Helper.addClass(document.querySelector("body"), "notes-open");

        setTimeout(() => {
          Helper.addClass(targetOverlay, "fade-in");
        }, 300);
      });
    });

    this.closebtnArray.forEach(item => {
      item.addEventListener("click", e => {
        this.closeOverlay(event.target);
      });
    });

    this.backdropsArray.forEach(item => {
      item.addEventListener("click", e => {
        this.closeOverlay(event.target);
      });
    });
  }

  closeOverlay(el) {
    const parent = Helper.getClosest(el, this.overlaysString);
    Helper.removeClass(parent, "fade-in");
    Helper.removeClass(document.querySelector("body"), "notes-open");
    setTimeout(() => {
      Helper.removeClass(parent, "is-visible");
    }, 300);
  }
}

export default interactiveMap;
